import * as React from "react";
const SvgRemove20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8 3a1 1 0 0 1 2 0H8ZM6 3a3 3 0 0 1 6 0h6v2H0V3h6ZM4 16V6H2v12h14V6h-2v10H4Zm6-2V7h2v7h-2ZM6 7v7h2V7H6Z",
      clipRule: "evenodd"
    })
  );
export default SvgRemove20Px;
